import { useSelector } from "react-redux";

import { UserFields } from "~/types/cart";

import styles from "./index.module.scss";

export default function BuyerInfo() {
  const { params } = useSelector((state: any) => state.cart);
  return (
    <div>
      <div className={styles.Title}>Покупатель</div>
      <div className={styles.Frame}>
        <div>
          <div>Фамилия, имя и отчество</div>
          <div>{params[UserFields.name]}</div>
        </div>
        <div>
          <div>Телефон</div>
          <div>{params[UserFields.phone]}</div>
        </div>
      </div>
    </div>
  );
}
